"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "campomorone": {
    "ecf7f5a9": [{
      "hkey": "1414d32d",
      "slug": "isoverde-gallaneto",
      "name": "Isoverde-Gallaneto",
      "primary": true,
      "skipSearch": false
    }],
    "isolaverde-gallaneto": [{
      "hkey": "1414d32d",
      "slug": "isoverde-gallaneto",
      "name": "Isoverde-Gallaneto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6150a20b": [{
      "hkey": "1414d32d",
      "slug": "isoverde-gallaneto",
      "name": "Isoverde-Gallaneto",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;